const authRoutes = [
	{
		path: '/auth/login',
		name: 'login',
		meta: {
			name: 'Login',
		},
		component: () => import('@/apps/auth/Login.vue'),
	},

	{
		path: '/auth/not-authorized',
		name: 'not-authorized',
		meta: {
			name: 'Not Authorized',
		},
		component: () => import('@/apps/auth/NotAuthorized.vue'),
	},

	{
		path: '/auth/forgot-password',
		name: 'forgot-password',
		meta: {
			name: 'Forgot Password',
		},
		component: () => import('@/apps/auth/ForgotPassword.vue'),
	},

	{
		path: '/auth/reset-link-sent',
		name: 'reset-link-sent',
		meta: {
			name: 'Reset Link Sent',
		},
		component: () => import('@/apps/auth/ResetLinkSent.vue'),
	},

	{
		path: '/auth/reset-password',
		name: 'reset-password',
		meta: {
			name: 'Reset Password',
		},
		component: () => import('@/apps/auth/ResetPassword.vue'),
	},

	{
		path: '/auth/sso/success',
		name: 'sso-success',
		meta: {
			name: 'SSO Login',
		},
		component: () => import('@/apps/auth/SsoSuccess.vue'),
	},
]

export default authRoutes
